import { get } from "./api";

export async function getIssue(issueKey: string) {
  const { data = {} } = await get({ path: `/jira/issues/${issueKey}` });
  return data;
}
